import { Injectable } from '@angular/core';

/** Perfil del flujo de restablecer contraseña. */
export type ResetPasswordProfile = 'token-virtual' | 'ccsw5';

/**
 * Contexto del flujo activo. Lo fija el contenedor admin según la ruta.
 * Los steps reutilizan ResetPasswordService, que lee este perfil para armar los paths.
 */
@Injectable({ providedIn: 'root' })
export class ResetPasswordFlowContext {
  private profile: ResetPasswordProfile = 'token-virtual';

  setProfile(profile: ResetPasswordProfile): void {
    this.profile = profile;
  }

  getProfile(): ResetPasswordProfile {
    return this.profile;
  }

  get isCcsw5(): boolean {
    return this.profile === 'ccsw5';
  }
}
